const wrapper = "_35swf0pwzw";

export { wrapper };
import "./_task.sentence.style.linaria.module.css";
//# sourceMappingURL=_task.sentence.style.js.map
